/**
 * Service de gestion des bagages
 * Centralise tous les appels API liés aux bagages et stratégies
 */
import apiService from './api.service';

class LuggageService {
  /**
   * Créer une stratégie de bagage
   */
  async createStrategy(strategyData) {
    return await apiService.post('strategieBagage', strategyData);
  }

  /**
   * Obtenir la stratégie par compagnie
   */
  async getStrategyByCompany(companyId) {
    return await apiService.get(`strategieBagage/compagnie/${companyId}`);
  }

  /**
   * Mettre à jour une stratégie
   */
  async updateStrategy(strategyId, strategyData) {
    return await apiService.put(`strategieBagage/${strategyId}`, strategyData);
  }

  /**
   * Supprimer une stratégie
   */
  async deleteStrategy(strategyId) {
    return await apiService.delete(`strategieBagage/${strategyId}`);
  }

  /**
   * Enregistrer un bagage
   */
  async registerLuggage(luggageData) {
    return await apiService.post('bagage', luggageData);
  }

  /**
   * Suivre les bagages
   */
  async trackLuggage(ticketReference) {
    return await apiService.get(`bagage/suivi/${ticketReference}`);
  }

  /**
   * Obtenir les références de bagages
   */
  async getLuggageReferences() {
    return await apiService.get('reference/famille/referenceFamilleBagage');
  }

  /**
   * Obtenir les types de stratégies
   */
  async getStrategyTypes() {
    return await apiService.get('reference/famille/referenceFamilleTypeStrategieBagage');
  }
}

export default new LuggageService();
